import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";

const shows = [
  {
    tag: "Hosted by Simply Jess",
    title: "The Woman's Power Playbook",
    desc: "Healing, strength, and becoming her. Solo conversations, personal reflections, and power-building perspective.",
    img: "/assets/womans-power-playbook-web.jpg",
    href: "https://open.spotify.com/search/The%20Woman%27s%20Power%20Playbook%20Simply%20Jess",
  },
  {
    tag: "Together",
    title: "Building Better: Unfiltered Love",
    desc: "Raw conversations on love, growth, partnership, communication, and building better in real life.",
    img: "/assets/building-better-unfiltered-love-logo.jpeg",
    href: "https://open.spotify.com/search/Building%20Better%20Unfiltered%20Love",
  },
];

export default function ConnectedShows() {
  return (
    <section className="relative py-24 sm:py-32" data-testid="connected-shows-section">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <div className="mb-14 max-w-2xl">
          <p className="overline text-blaze mb-4">Connected shows</p>
          <h2 className="font-heading font-800 tracking-tight text-4xl sm:text-5xl leading-tight">
            More voices in the same movement.
          </h2>
        </div>
        <div className="grid md:grid-cols-2 gap-5">
          {shows.map((s, i) => (
            <motion.a
              key={s.title}
              href={s.href}
              target="_blank"
              rel="noreferrer"
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: i * 0.1 }}
              className="group flex gap-5 rounded-2xl border border-white/10 bg-charcoal p-5 hover:-translate-y-1 transition-transform"
              data-testid={`connected-show-${i}`}
            >
              <img
                src={s.img}
                alt={s.title}
                className="h-28 w-28 rounded-xl object-cover bg-black shrink-0"
              />
              <div className="flex-1">
                <p className="overline text-white/40">{s.tag}</p>
                <h3 className="mt-2 font-heading font-700 text-lg flex items-center gap-2">
                  {s.title}
                  <ArrowUpRight size={16} className="text-blaze opacity-0 group-hover:opacity-100 transition-opacity" />
                </h3>
                <p className="mt-2 text-sm text-white/55 leading-relaxed">{s.desc}</p>
              </div>
            </motion.a>
          ))}
        </div>
      </div>
    </section>
  );
}
